/**
 * Creates an Accordion group build up of Details which only 1 can be open at a time.
 * 
 * @export
 * @class Accordions
 */
import { forEach } from '../../helpers/utilities';

import { Accordion } from './accordion';

export class Accordions {

    constructor() {
        const accordions = document.querySelectorAll('[data-accordion]');
        if(accordions) {
            forEach(accordions, ({}, accordion: HTMLElement) => {
                new Accordion(accordion);
            });
        }
    }
}
